<svg
  #layerSvg
  class="gate-block-svg"
  viewBox="0 0 1182 1772"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  (pointermove)="onLayerPointerMove($event)"
  (pointerup)="onLayerPointerUp($event)"
  (pointercancel)="onLayerPointerUp($event)"
>
  @for (b of displayBlockVms(); track b.key) {
    <g
      class="gate-block"
      [class.is-dimmed]="isBlockDimmed(b)"
      [class.is-hover-outlined]="isBlockOutlined(b)"
      (mouseenter)="onBlockEnter(b)"
      (mouseleave)="onBlockLeave()"
      (pointerdown)="onBlockPointerDown(b, $event)"
      (dblclick)="onBlockDblClick(b)"
    >
      <rect
        class="gate-block-rect"
        [attr.x]="b.rect.x"
        [attr.y]="b.rect.y"
        [attr.width]="b.rect.width"
        [attr.height]="b.rect.height"
        rx="6"
        [attr.fill]="b.fill"
        [attr.stroke]="b.stroke"
        [attr.stroke-width]="b.stroke ? 2 : null"
      />
      <text
        class="gate-block-glyph"
        [attr.x]="b.rect.x + b.rect.width / 2"
        [attr.y]="b.rect.y + b.rect.height / 2"
        [attr.fill]="b.glyphFill"
        text-anchor="middle"
        dominant-baseline="central"
      >{{ b.glyph }}</text>
      @if (moveToolActive() && b.pinned) {
        <circle
          class="gate-block-pin-dot"
          [attr.cx]="b.rect.x + b.rect.width - 6"
          [attr.cy]="b.rect.y + 6"
          r="6"
        />
      }
    </g>
  }
</svg>
